import { render } from "./StaticGalleryPage.vue?vue&type=template&id=58fbb8ca&scoped=true"
import script from "./StaticGalleryPage.vue?vue&type=script&lang=js"
export * from "./StaticGalleryPage.vue?vue&type=script&lang=js"

import "./StaticGalleryPage.vue?vue&type=style&index=0&id=58fbb8ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fbb8ca"]])

export default __exports__